import { render } from "./BotonGuardar.vue?vue&type=template&id=a8553120&scoped=true"
import script from "./BotonGuardar.vue?vue&type=script&lang=js"
export * from "./BotonGuardar.vue?vue&type=script&lang=js"

import "./BotonGuardar.vue?vue&type=style&index=0&id=a8553120&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8553120"]])

export default __exports__